import { render } from "./TheAboutUs.vue?vue&type=template&id=bb868aa4"
import script from "./TheAboutUs.vue?vue&type=script&lang=js"
export * from "./TheAboutUs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__